export default __webpack_public_path__ + "/assets/fonts/inter-vietnamese-wght-normal.woff2";